module.exports = __webpack_public_path__ + "img/WiDE_Logo_Light.036658d7.png";